import { IDashboardMetadata, IDashboardSectionMetadata } from '../dashboard-metadata.service';
import { Chart } from '../../chart/base-chart.component';
import { LARGE_QUOTE_KPI, ORDER_KPI_COLUMNS, ORDERS_PASSED_SLA_CONFIG, TICKET_KPI_CONFIG, VIP_COLUMNS } from './shared-dashboard.config';
import { OdDashboardFiltersComponent } from '../filters/od/od-dashboard-filters.component';
import { OrderDashboardHeaderComponent } from '../header/order-dashboard-header.component';

export const OD_ORDER_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'Order KPI',
  headerComponent: {
    name: OrderDashboardHeaderComponent
  },
  filterComponent: {
    name: OdDashboardFiltersComponent,
    inputs: {
      showCustomerFilter: true,
      showNAMFilter: true,
      showDIYFilter: true
    }
  },
  chartLink: Chart.BP,
  // !!! everytime when adding a new mapping filter -> make sure that the column is added also in all reports defined in export.reports (otherwise the filter won't be applied when exporting the report)
  mapping: {
    Odlname: 'pss.id',
    Pacomnm: 'bp.companyCountryId',
    Decurce: 'currency.id',
    Devincl: 'vatIncl.id',
    Desprnm: 'customer.id',
    Cucomid: 'customerCompany.id',
    Decgrid: 'companyGroup.id',
    Pacgrid: 'bpGroup.id',
    Denamid: 'nam.id',
    Doityourself_ds: 'diy.id',
    Oddesk: 'bpDesk'
  },
  export: {
    reports: [
      {
        id: 81,
        key: 'OPEN_ITEMS'
      },
      {
        id: 113,
        key: 'ASSET_ITEMS',
        templateCode: 'UPLOAD_ASSET',
        filters: { // should contain the same filters as MISSING_ORDER_INFO
          Sow_list: '144,145', // Serial # Reporting & Warranty/Software License Registration
          Destoty_ds: 'NO', // Normal order
          Serial_before_shipping: 1, // shipped and serial nrs required before shipping
          Deserav: ' ', // serial number available
          Exclude_non_relevant_pending: 1
        },
        mapping: {
          Decomnm: 'bp.companyCountryId',
          Cucgrid: 'companyGroup.id'
        }
      },
      {
        id: 225,
        key: 'MISSING_INVOICES',
        templateCode: 'UPLOAD_BP_INVOICE',
        filters: {
          Problem: '1,2',
          Devincl: 1
        }
      },
      {
        id: 228,
        key: 'ALL_ITEMS'
      }
    ]
  },
  fixedFilters: {
    Decurce: 'EUR',
    Devincl: '0'
  },
  reports: [
    {
      id: 219,
      key: 'DUE_INVOICES'
    },

    {
      id: 221,
      key: 'VIP_ORDERS',
      columns: VIP_COLUMNS,
      fixedFilters: {
        Devipnr: 'VIP'
      }
    },

    {
      id: 220,
      key: 'ORDERS_NOT_PLACED',
      comments: `Orders that have not been placed by the reseller <br>\n ` +
        `      This means that the order was submitted and:\n ` +
        `      <ul>\n` +
        `        <li>Has no placement date</li>\n` +
        `        <li>Or is in state \'Validated\'</li>\n` +
        `        <li>Or doesn\'t have one of the \'BP to Distri\', \'BP to OEM\' or \'Distri to OEM\' numbers (depending on order placement type)</li>\n` +
        `      </ul>`,
      fixedFilters: {
        Kpitype: 'ORDERS_NOT_PLACED'
      },
      columns: ORDER_KPI_COLUMNS
    },

    {
      id: 222,
      key: 'ORDERS_WITHOUT_OFFER',
      fixedFilters: {
        Dereqst: 'SUBMIT'
      },
      columns : [
        'Devipnr_ds',
        'Urgent_order_description',
        'Dereqid',
        'Depornr',
        'Decompa',
        'Decounm',
        'Detotal',
        'Actotal',
        'Desubdt',
        'Decredt',
        'Dersudt',
        'Decommt',
        'Lead_time',
        'Devaldt',
        'Odlname',
        'Oddesk',
        'Pacomnm',
        'Stocktype',
        'Denamnm',
        'Delamnm',
        'Lacomnm',
        'Delamcn',
        'Deqstat',
        'Deprdgr',
        'Gblname',
        'Dereqst',
        'Decomds',
        'Deenddt',
        'Dereqnm',
        'Decsunm',
        'Desk',
        'Doityourself_ds'
      ]
    },

    {
      id: 220,
      key: 'ORDERS_NEW_PRICES',
      fixedFilters: {
        Changed_prices: 1
      }
    },

    getPendingKPIConfig('PENDING_CUSTOMER', 'C'),
    getPendingKPIConfig('PENDING_BP', 'P'),
    getPendingKPIConfig('PENDING_VENDOR', 'V'),
    getPendingKPIConfig('PENDING_DISTRIBUTOR', 'D'),
    getPendingKPIConfig('PENDING_ACSL', 'A'),
    getPendingKPIConfig('PENDING_CATALOG', 'CATOWNER'),

    {
      id: 77,
      key: 'ETA_LESS_1W',
      comments: 'ETA <= 1 week (5 business days)',
      fixedFilters: {
        Deetady: 'between 0 and 5'
      },
      mapping: {
        Denname: 'bp.companyCountryId',
        Pacomnm: 'bp.company.id'
      },
      columns: [
        //(!),
        'Deordnr',//ACSL #
        {
          name: 'Internal_order_nr',
          label: 'BP internal order #'
        },
        {
          name: 'Debpref',
          label: 'BP to OEM #'
        },
        {
          name: 'Debdref',
          label: 'BP to Distri #'
        },
        'Decomds',//Status
        'Decommt',//Comment
        {
          name: 'Deetadt',
          label: 'ETA date'
        },
        'Deshpdt',//Ship date
        {
          name: 'Desprnm',
          label: 'Company'
        },
        'Decounm',//Country
        'Denname',//BP
        'Odlname',//OD
        'Delamnm',//LAM
        'Desubdt',//Submit date
        'Lacomnm',//LAM Company
        'Gblname',//GBDM
        'Stocktype'
      ]
    },

    {
      id: 226,
      key: 'ETA_EXPIRED',
      fixedFilters: {
        Dewdfid: '69'
      },
      columns: [
        'Devipnr_ds',
        'Dereqid',
        'Depornr',
        'Internal_order_nr',
        'Debpref',
        'Debdref',
        'Deveref',
        'Dereqst',
        'Decommt',
        'Deetadt',
        'Deshpdt',
        'Detotal',
        'Actotal',
        'Denamnm',
        'Decompa',
        'Decounm',
        'Pacomnm',
        'Odlname',
        'Oddesk',
        'Desubdt',
        'Delamnm',
        'Lacomnm',
        'Delamcn',
        'Gblname',
        'Decsunm',
        'Decomds',
        'Deenddt',
        'Vendor',
        'Vglname',
        'Stocktype',
        'Desk',
        'Doityourself_ds'
      ]
    },

    {
      id: 220,
      key: 'ORDERS_WITHOUT_OEM',
      comments: ' ',
      fixedFilters: {
        Kpitype: 'ORDERS_NO_OEM',
        Need_oem_nr: 1
      },
      columns: ORDER_KPI_COLUMNS
    },

    {
      id: 224,
      key: 'NEED_SHIP_DATE',
      fixedFilters: {
        Kpitype: 'PLACED_INDIRECTLY',
        Noshipdateorexpired: 1
      }
    },

    {
      id: 225,
      key: 'MISSING_INVOICE',
      fixedFilters: {
        Problem: '1,2'
      }
    },

    {
      id: 225,
      key: 'MISSING_ORDER_INFO',
      fixedFilters: {
        Problem: '3,4'
      },
      alternateReport: {
        id: 113,
        fixedFilters: {
          Sow_list: '144,145', // Serial # Reporting & Warranty/Software License Registration
          Destoty_ds: 'NO', // Normal order
          Serial_before_shipping: 1, // shipped and serial nrs required before shipping
          Deserav: ' ', // serial number available
          Exclude_non_relevant_pending: 1
        },
        mapping: {
          Decomnm: 'bp.companyCountryId',
          Cucgrid: 'companyGroup.id'
        }
      }
    },

    {
      id: 225,
      key: 'MASTER_STOCK_WAITING_DELIVERY',
      fixedFilters: {
        Problem: '5'
      },
      alternateReport: {
        id: 113,
        fixedFilters: {
          Eta_bp_expired: 1,
          Received_bp: ' '
        },
        storedReport: 'STOCK_ORDER_DELIVERY_DATE_AT_BP',
        exportTemplate: 'UPLOAD_DELIVERY_AT_BP',
        mapping: {
          Decomnm: 'bp.companyCountryId',
          Cucgrid: 'companyGroup.id'
        }
      }
    },

    {
      id: 205,
      key: 'MISSING_POD',
      fixedFilters: {
        Dedocok_pod: 0, // POD Uploaded -> no
        Deneeds_pod: 1, // POD requested -> Yes
        Dereqst: '3234846615', // Open,
        Deshipp: 1 // Shipped by customer -> Yes
      },
      columns: [
        'Devipnr_ds', // VIP
        'Dereqid', // ACSL #
        'Depornr', // PO #
        'Pod', // Upload POD
        'Dereqst', // Main status
        'Decommt', // Comment
        'Deshpdt', // Ship date
        'Desprnm', // Webshop
        'Decounm', // Country
        'Pacomnm', // BP
        'Odlname', // OD
        'Desubdt', // Submit date
        'Delamnm', // LAM
        'Lacomnm', // LAM company
        'Delamcn', // LAM contact
        'Gblname', // GBDM
        'Denamnm', // NAM
        'Decsunm', // Sub company
        'Decomds', // Detailed status
        'Desk', // GBDM Desk
        'Doityourself_ds', // DIY
        'Oddesk', // OD Desk
        'Stocktype', // Stock type
        'Internal_order_nr' // BP internal order nr
      ]
    },

    {
      id: 227,
      key: 'SHIPPED_NOT_CLOSED'
    },

    {
      browselistCode: 'TICKET',
      key: 'OPEN_SERVICE_TICKETS',
      fixedFilters: {
        Deiopen: 1,
        Categorygroup: 'SERVICE'
      },
      mapping: TICKET_KPI_CONFIG.mapping,
      columns: TICKET_KPI_CONFIG.columns
    },

    {
      browselistCode: 'TICKET',
      key: 'OPEN_PO_TICKETS',
      fixedFilters: {
        Deiopen: 1,
        Dewtyds: 'TODO_PO'
      },
      mapping: TICKET_KPI_CONFIG.mapping,
      columns: TICKET_KPI_CONFIG.columns
    },

    {
      browselistCode: 'TICKET',
      key: 'OPEN_TICKETS',
      fixedFilters: {
        Deiopen: 1,
        Dewtyds: 'TODO_IT,TODO_PR,TODO_BP,TODO_CO,TODO_CY,TODO_INV'
      },
      mapping: {
        Deccoid: 'bp.companyCountryId',
        Shsprnm: 'customer.id'
      }
    },

    {
      id: 43,
      key: 'ORDERS_PASSED_SLA_NO_MAIN_PENDING',
      fixedFilters: ORDERS_PASSED_SLA_CONFIG.fixedFilters,
      mapping: ORDERS_PASSED_SLA_CONFIG.mapping,
      sort: ORDERS_PASSED_SLA_CONFIG.sort,
      columns: ORDERS_PASSED_SLA_CONFIG.columns
    },

    {
      id: 43,
      key: 'ORDERS_PASSED_SLA',
      fixedFilters: {
        ...ORDERS_PASSED_SLA_CONFIG.fixedFilters,
        Mainpendingcheckedtext: 0
      },
      mapping: ORDERS_PASSED_SLA_CONFIG.mapping,
      sort: ORDERS_PASSED_SLA_CONFIG.sort,
      columns: ORDERS_PASSED_SLA_CONFIG.columns
    },

    {
      id: 85,
      key: 'EXPIRED_LOCAL_CUST_INVOICES',
      fixedFilters: {
        Deexpdt: '>=5',
        Deexpir_ds: 1,
        Deshort: null
      },
      mapping: {
        Decodnm: 'pss.id'
      },
      columns: [
        'Avg_payment_terms',
        'Dereqid',

        'Decomds',
        'Deinvnr',
        'Deinvdt',
        'Depayst_ds',
        'Decommt_sh',
        {
          name: 'Decomnm',
          label: 'Company'
        },
        'Decounm',
        'Pacomnm',
        'Decodnm',
        'Degbdmn',
        'Lam',
        'Stocktype',
        'Internal_order_nr'
      ]
    },

    {
      id: 228,
      key: 'ALL_OPEN'
    },

    {
      id: 1,
      key: 'CALL_OFF_ORDERS_FROM_STOCK',
      fixedFilters: {
        Destoty_ds: 'NO',
        Call_off_orders: ' ' //column-default 58 has values blank space for Yes or 'NOT' for No.
      },
      mapping: {
        Decodid_ds: 'pss.id',
        Denname: 'bp.companyCountryId',
        Paemail: 'nam.id',
        Pacomnm: 'bp.company.id'
      },
      columns: [
        'Weekssubmitted',
        'Devipnr_ds',
        'Depornr',
        'Dereqid',
        'Deorddt',
        'Decounm',
        'Deetadt',
        'Destatu',
        'Destadt',
        'Shstaco',
        'Dereqst_ds',
        'Cucomnm',
        'Pacomnm',
        'Paemail',
        'Decodid_ds',
        'Internal_order_nr'
      ],
      sort: [
        {
          name: 'Weekssubmitted',
          direction: 'desc'
        }
      ]
    },

    {
      browselistCode: 'QUOTE_EDIT',
      key: 'LARGE_QUOTES',
      fixedFilters: LARGE_QUOTE_KPI.fixedFilters,
      mapping: {
        Decodid_ds: 'pss.id',
        Denname: 'bp.companyCountryId',
        Paemail: 'nam.id',
        Pacomnm: 'bp.company.id'
      },
      columns: LARGE_QUOTE_KPI.columns,
      sort: LARGE_QUOTE_KPI.sort
    }
  ]
};

function getPendingKPIConfig(sectionTitleKey:string, type:string):IDashboardSectionMetadata {
  return {
    id: 223,
    key: sectionTitleKey,
    fixedFilters: {
      Customer_kpi_section: type
    },
    mapping: {
      Decurce: 'currency.id'
    },
    columns: [
      'Devipnr_ds',
      'Dereqid_ds',
      'Depornr',
      'Pending_date',
      'Age',
      'Dereqst',
      'Owner_type',
      'Owner',
      'Decommt',
      'Decompa',
      'Decounm',
      'Detotal',
      'Actotal',
      'Desubdt',
      'Odlname',
      'Pacomnm',
      'Delamnm',
      'Lacomnm',
      'Delamcn',
      'Decsunm',
      'Decomds',
      'Customer_kpi_section',
      'Kpi_dashboard_name',
      'Gblname',
      'Desk',
      'Deetadt',
      'Doityourself_ds',
      'Oddesk',
      'Vnam',
      'Vrep',
      'Internal_order_nr',
      'Debpref',
      'Dedvref',
      'Deveref',
      'Stocktype',
      'Denamnm'
    ]
  };
}